import type { CallbackFlowOutcome, CallbackNotice } from '../models/callback.types'
import { CONNECTIONS_ROUTE } from '../routeTarget'

const LOGIN_ROUTE = { name: 'Login' } as const
const SUMMARY_ROUTE = { name: 'Summary' } as const

export type ResultToastBranch =
  'shopify-success' | 'shopify-error' | 'workspace_shopify_error' | 'connect' | 'error_occured'

export interface ResultToastOutcome {
  notice: CallbackNotice
  redirect?: CallbackFlowOutcome
}

export function resultToast(
  branch: ResultToastBranch,
  detail: string,
  errorOccurred = false,
): ResultToastOutcome {
  const params = { detail }
  if (branch === 'shopify-success') {
    return {
      notice: { tone: 'success', key: 'integrations.result.info', params },
      redirect: { destination: LOGIN_ROUTE },
    }
  }
  if (branch === 'shopify-error') {
    return {
      notice: { tone: 'warning', key: 'integrations.result.error', params },
      redirect: { destination: SUMMARY_ROUTE },
    }
  }
  if (branch === 'workspace_shopify_error') {
    return {
      notice: { tone: 'warning', key: 'integrations.result.error', params },
      redirect: { destination: CONNECTIONS_ROUTE },
    }
  }
  if (branch === 'error_occured' && errorOccurred) {
    return { notice: { tone: 'error', key: 'integrations.result.error', params } }
  }
  return { notice: { tone: 'success', key: 'integrations.result.info', params } }
}
